<template>
  <el-dialog title="产品检索" :visible.sync="dialogVisible" append-to-body :close-on-click-modal="false" width="80%">

    <el-tabs v-model="activeName" @tab-click="handleClick">
      <el-tab-pane label="产品" name="first">
        <QueryModel :classType="0" ref="queryClassModelTab"></QueryModel>
      </el-tab-pane>
      <el-tab-pane label="原材料" name="second">
        <QueryModel :classType="1" ref="queryMaterModelTab"></QueryModel>
      </el-tab-pane>
    </el-tabs>
  </el-dialog>
</template>

<script>
  import QueryModel from "./queryModel.vue";

  export default {
    components: { QueryModel },
    props: {

    },
    data() {
      return {
        dialogVisible: false,
        activeName: 'first'
      };
    },
    created() {

    },
    methods: {
      init() {
        this.dialogVisible = true
      },
      handleClick(tab, event) {
        if (tab.name == 'first') {
          this.$refs.queryClassModelTab.getList()
        } else if (tab.name == 'second') {
          this.$refs.queryMaterModelTab.getList()
        }
      },
    },

  }
</script>

<style lang="scss" scoped>
  .ml10 {
    margin-left: 10px;
  }

  .pageBox {
    display: flex;
    justify-content: flex-end;
  }
</style>